import React from "react";

// Official GMOAA emblem (Dhanvantari) — circular logo asset.
export const LeafLogo = ({ size = 40, className = "" }) => (
  <img
    src="/gmoaa-logo.png"
    alt="GMOAA — Ayurved Medical Officers Association, Gujarat State emblem"
    width={size}
    height={size}
    loading="eager"
    className={`rounded-full object-contain ${className}`}
    style={{ width: size, height: size }}
  />
);
